import * as React from "react";
import * as ReactDOM from "react-dom/client";
import './styles/index.css';
import reportWebVitals from './reportWebVitals';
import Provider from "./provider/index"


ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider></Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
